import { v4 as uuidv4 } from "uuid";
import { collection, addDoc } from "firebase/firestore";
import { Event, subscribe } from "qwick/dist/event";
import { db } from "./firebase";

export type EventDoc = {
    userId: string;
    gameId: string;
    timestamp: number;
    event: Event;
};

export const handleEvents = (gameId: string) => {
    if (localStorage["userId"] === undefined) localStorage["userId"] = uuidv4();

    const userId = localStorage["userId"];

    const unsubscribe = subscribe((event: Event) => {
        const col = collection(db, "events");
        const timestamp = Date.now();
        const eventDoc: EventDoc = { userId, gameId, timestamp, event };
        addDoc(col, eventDoc);
    });
    return unsubscribe;
};
